<template>
  <div class="main">
    <h2 class="title">投递方式</h2>
    <div class="container">
      <div class="mode">
        <p class="email-address">请将简历投递至邮箱：hr@zealcomm.cn</p>
        <p class="email-title">邮件标题：姓名+岗位名称</p>
        <p class="email-mode">简历命名格式：姓名+岗位名称</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import "./join.scss";

  .main {
    .title {
      @extend %title;
    }

    .mode {
      margin: 4% auto;
      padding: 4% 0;
      border-radius: 14px;
      background: #f5f5f7;
      color: #333;
      font-size: 20px;
      line-height: 40px;
      text-align: center;
    }
  }

  @media screen and (max-width: 992px) {
    .main {
      .title {
        font-size: 30px;

        &::before,
        &::after {
          background: unset;
        }
      }

      .mode {
        font-size: 16px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .main {
      .title {
        font-size: 20px;
      }

      .mode {
        font-size: 17px;
      }
    }
  }
</style>
